import React, { useState } from "react";

import korePlatform from '../../../css/img/kore-platform.svg';
import koreHover from '../../../css/img/kore-hover.svg'

import crmLight from '../../../css/img/crm-light.svg';
import crmDark from '../../../css/img/crm-dark.svg';
import crmHoverLight from '../../../css/img/crm-hover-light.svg';
import crmHoverDark from '../../../css/img/crm-hover-dark.svg';

import designedLight from '../../../css/img/designed-light.svg';
import designedDark from '../../../css/img/designed-dark.svg';
import designedHover from '../../../css/img/designed-hover.svg';

import mydevLight from '../../../css/img/mydev-light.svg';
import mydevDark from '../../../css/img/mydev-dark.svg';
import mydevHoverLight from '../../../css/img/mydev-hover-light.svg';
import mydevHoverDark from '../../../css/img/mydev-hover-dark.svg';

import ireviewLight from '../../../css/img/ireview-light.svg';
import ireviewDark from '../../../css/img/ireview-dark.svg';
import ireviewHoverLight from '../../../css/img/ireview-hover-light.svg';
import ireviewHoverDark from '../../../css/img/ireview-hover-dark.svg';

import ipaymerLight from '../../../css/img/ipaymer-light.svg';
import ipaymerDark from '../../../css/img/ipaymer-dark.svg';
import ipaymerHoverLight from '../../../css/img/ipaymer-hover-light.svg';
import ipaymerHoverDark from '../../../css/img/ipaymer-hover-dark.svg';

import claritickPlatform from '../../../css/img/claritick-platform.svg';

import claritaskLight from '../../../css/img/claritask-light.svg';
import claritaskDark from '../../../css/img/claritask-dark.svg';
import claritaskHoverLight from '../../../css/img/claritask-hover-light.svg';
import claritaskHoverDark from '../../../css/img/claritask-hover-dark.svg';

// import convosioLight from '../../../css/img/convosio-light.svg';
// import convosioDark from '../../../css/img/convosio-dark.svg';
// import convosioHover from '../../../css/img/convosio-hover.svg';

import sendbatLight from '../../../css/img/sendbat-light.svg';
import sendbatDark from '../../../css/img/sendbat-dark.svg';
import sendbatHover from '../../../css/img/sendbat-hover.svg';

import morsixLight from '../../../css/img/morsix-light.svg';
import morsixDark from '../../../css/img/morsix-dark.svg';
import morsixHover from '../../../css/img/morsix-hover.svg';

import smartboxPlatform from '../../../css/img/smartbox-platform.svg';
import smartboxHover from '../../../css/img/smartbox-hover.svg';

import "./platform-sidebar.css";

const platformItems = [
  {
    id: 1,
    label: "Kore.co",
    url: "https://accounts.kore.co/login",
    icons: {
      light: korePlatform,
      dark: korePlatform
    },
    iconsHover: {
      light: koreHover,
      dark: koreHover,
    },
    bgColors: {
      light: "#FFFAF0",
      dark: "#FFA100",
    },
  },
  {
    id: 2,
    label: "Customer Management",
    url: "https://accounts.kore.co/crm/",
    icons: {
      light: crmLight,
      dark: crmDark
    },
    iconsHover: {
      light: crmHoverLight,
      dark: crmHoverDark,
    },
    bgColors: {
      light: "#FFEDD5",
      dark: "#B45309",
    },
  },
  {
    id: 3,
    label: "Design System",
    url: "https://hub.designed.co/",
    icons: {
      light: designedLight,
      dark: designedDark
    },
    iconsHover: {
      light: designedHover,
      dark: designedHover,
    },
    bgColors: {
      light: "#F3E8FF",
      dark: "#5B2D8B",
    },
  },
  {
    id: 4,
    label: "Website Development",
    url: "https://hub.mydev.com/",
    icons: { light: mydevLight, dark: mydevDark },
    iconsHover: {
      light: mydevHoverLight,
      dark: mydevHoverDark,
    },
    bgColors: {
      light: "#E6EEFF",
      dark: "#0047AB",
    },
  },
  {
    id: 5,
    label: "Reputation Management",
    url: "https://app.irevu.com/login",
    icons: {
      light: ireviewLight,
      dark: ireviewDark
    },
    iconsHover: {
      light: ireviewHoverLight,
      dark: ireviewHoverDark
    },

    bgColors: {
      light: "#DCFCE7",
      dark: "#1E8E5A",
    },
  },
  {
    id: 6,
    label: "Invoice & Online Banking",
    url: "https://ipaymer.com/login",
    icons: {
      light: ipaymerLight,
      dark: ipaymerDark
    },
    iconsHover: {
      light: ipaymerHoverLight,
      dark: ipaymerHoverDark,
    },
    bgColors: {
      light: "#CCFBF1",
      dark: "#0D9488",
    },
  },
  {
    id: 7,
    label: "Ticket Management",
    url: "https://claritick.com/login",
    icons: {
      light: claritickPlatform,
      dark: claritickPlatform
    },
    bgColors: {
      light: "#EDE9FE",
      dark: "#1E1B4B",
    },
    isCurrent: true,
  },
  {
    id: 8,
    label: "Task Management",
    url: "https://accounts.kore.co/login?platform=nKxQ8zlxVFRfuOPG4et2nKxQ8zlxVFRfu",
    icons: {
      light: claritaskLight,
      dark: claritaskDark
    },
    iconsHover: {
      light: claritaskHoverLight,
      dark: claritaskHoverDark,
    },
    bgColors: {
      light: "#EDE9FE",
      dark: "#02164A",
    },
  },
  /* {
    id: 9,
    label: "Chat System",
    url: "https://accounts.kore.co/login?platform=64040b9bc3aced7c112f56b8e162d50",
    icons: {
      light: convosioLight,
      dark: convosioDark
    },
    iconsHover: {
      light: convosioHover,
      dark: convosioHover,
    },
    bgColors: {
      light: "#F7FEE7",
      dark: "#65A30D",
    },
  }, */
  {
    id: 10,
    label: "Email & SMS Marketing",
    url: "https://sendbat.com/login",
    icons: {
      light: sendbatLight,
      dark: sendbatDark
    },
    iconsHover: {
      light: sendbatHover,
      dark: sendbatHover,
    },
    bgColors: {
      light: "#FEE2E2",
      dark: "#B91C1C",
    },
  },
  {
    id: 11,
    label: "Warehouse Management",
    url: "https://accounts.kore.co/login?platform=lSTMKEPxq91nR0d28kgpPxq91nR0kgpP",
    icons: {
      light: morsixLight,
      dark: morsixDark
    },
    iconsHover: {
      light: morsixHover,
      dark: morsixHover,
    },
    bgColors: {
      light: "#E5E7EB",
      dark: "#1F2933",
    },
  },
  {
    id: 12,
    label: "Key Programming",
    url: "https://account.smartboxauto.com/main/login",
    icons: {
      light: smartboxPlatform,
      dark: smartboxPlatform
    },
    iconsHover: {
      light: smartboxHover,
      dark: smartboxHover,
    },
    bgColors: {
      light: "#E3EDF5",
      dark: "#30516E",
    },
  },
];

const PlatformSidebar = ({ theme }) => {
  const [hoveredId, setHoveredId] = useState(null);
  return (
    <aside className="platform-sidebar">
      <div className="platform-sidebar-inner">
        {platformItems.map((item) => {
          const isHovered = hoveredId === item.id && !item.isCurrent;
          const platformBgColor =
            theme === "dark" ? item.bgColors.dark : item.bgColors.light;

          const iconSrc = isHovered && item.iconsHover
            ? (theme === "dark" ? item.iconsHover.dark : item.iconsHover.light)
            : (theme === "dark" ? item.icons.dark : item.icons.light);

          const showTooltip = !item.isCurrent;

          const content = (
            <>
              {showTooltip && (
                <span
                  className="platform-sidebar-tooltip"
                  style={{ backgroundColor: platformBgColor }}
                >
                  {item.label}
                  <span
                    className="platform-sidebar-tooltip-arrow"
                    style={{ borderLeftColor: platformBgColor }}
                  />
                </span>
              )}

              <div className="platform-sidebar-logo-wrap">
                <img
                  src={theme === "dark" ? item.icons.dark : item.icons.light}
                  alt={item.label}
                  className="platform-sidebar-logo platform-sidebar-logo-default"
                />

                {item.iconsHover && !item.isCurrent && (
                  <img
                    src={theme === "dark" ? item.iconsHover.dark : item.iconsHover.light}
                    alt=""
                    aria-hidden="true"
                    className="platform-sidebar-logo platform-sidebar-logo-hover"
                  />
                )}
              </div>
            </>
          );

          if (item.isCurrent) {
            return (
              <span
                key={item.id}
                className="platform-sidebar-item platform-sidebar-item-current"
                aria-current="page"
                style={{ "--platform-hover-bg": platformBgColor }}
              >
                {content}
              </span>
            );
          }

          return (
            <a
              key={item.id}
              href={item.url}
              className={`platform-sidebar-item${item.id === 1 ? " platform-sidebar-item--kore" : ""}`}
              aria-label={item.label}
              target="_blank"
              rel="noopener noreferrer"
              style={{ "--platform-hover-bg": platformBgColor }}
              onMouseEnter={() => setHoveredId(item.id)}
              onMouseLeave={() => setHoveredId(null)}
              onFocus={() => setHoveredId(item.id)}
              onBlur={() => setHoveredId(null)}
            >
              {content}
            </a>
          );
        })}
      </div>
    </aside>
  );
};

export default PlatformSidebar;